import { Component, ChangeDetectionStrategy, input } from '@angular/core';
import { SvgIconComponent } from 'angular-svg-icon';
import { TooltipsModule } from '@progress/kendo-angular-tooltip';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-info-tooltip',
    templateUrl: './info-tooltip.component.html',
    styleUrls: ['./info-tooltip.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, SvgIconComponent, TooltipsModule],
})
export class InfoTooltipComponent {
    readonly title = input<string>('');
    readonly size = input<string>('20px');
}
